import { render, staticRenderFns } from "./ModelInfoPage.vue?vue&type=template&id=6f933f9e&scoped=true"
import script from "./ModelInfoPage.vue?vue&type=script&lang=js"
export * from "./ModelInfoPage.vue?vue&type=script&lang=js"
import style0 from "./ModelInfoPage.vue?vue&type=style&index=0&id=6f933f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f933f9e",
  null
  
)

export default component.exports